import { render, staticRenderFns } from "./DatatableTransparencySubTypes.vue?vue&type=template&id=0f6f52ec&scoped=true&"
import script from "./DatatableTransparencySubTypes.vue?vue&type=script&lang=js&"
export * from "./DatatableTransparencySubTypes.vue?vue&type=script&lang=js&"
import style0 from "./DatatableTransparencySubTypes.vue?vue&type=style&index=0&id=0f6f52ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f52ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
